import {Response} from '@angular/http';

export function extractData(res: Response) {
  let body = res.json();
  let jsonBody = body || {};
  let normalized = jsonBody.data ? normalizeResponse(jsonBody.data) : jsonBody;
  return normalized;
}

export function toFormObject(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

export function normalizeResponse(response: any) {

  if (response == undefined) {
    return response;
  }

  // if array normalize array
  if (response && response instanceof Array) {
    return response.map(e => normalizeResponse(e));
  } else if (response.constructor == Object) {

    // if hash, normalize the hash
    let resp = Object.assign({}, response);

    let objectKeys = Object.keys(response);
    for (var i in objectKeys) {
      let key = objectKeys[i];

      if (response[key] && response[key].data && response[key].data instanceof Array) {
        let dataArr = response[key].data;
        resp[key] = dataArr.map((data) => normalizeResponse(data));
      } else if (response[key] && response[key].data && response[key].data.constructor == Object) {
        let keys = Object.keys(response[key].data);
        let e = {};
        for (var v in keys) {
          let vKey = keys[v];
          e[vKey] = normalizeResponse(response[key].data[vKey]);
        }
        resp[key] = e;
      } else {
        resp[key] = response[key];
      }

    }

    return resp;
  } else {
    return response;
  }


}


// WEBPACK FOOTER //
// ./src/app/services/utils.ts